import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { InvoiceLineItem } from "@common/types/invoice";
import { capitalize } from "@common/helpers/string";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import styles from "./ItemCell.module.scss";

export const KindCell = memo(
    ({ row }: CellContext<ViewTableFeatures, InvoiceLineItem, unknown>) => (
        <ViewTableCell className={styles.item}>
            {capitalize(row.original.kind)}
        </ViewTableCell>
    ),
);
